// import ScrollingNewsFilter from '@wearesection/bandai-react-components/organisms/ScrollingNewsFilter';
import Box from '@mui/material/Box';
import * as Types from 'graphql/types';
import {GetRouter} from '~/utils';
import React, {useMemo} from 'react';
import {handleConvertToLocaleContentful} from '~/utils';
import {CONVERT_VALUE_FILTER} from './convertValueFilter';
import dynamic from 'next/dynamic';
const ScrollingNewsFilter = dynamic(
  () => import('@wearesection/bandai-react-components/organisms/ScrollingNewsFilter'),
  {ssr: false}
);
type INewsFilterExt = {
  data: Types.NewsListing;
  activeSlug?: string;
  onQueryTags: (v?: any) => void;
  onQueryGame: (v?: any) => void;
  onActiveSlug: (v?: any) => void;
};

const handleCheckActiveFilter = (tag: string, tagFilter: any[], parent = '') => {
  const lengthParent = parent.length;

  const newParent = parent.substring(0, lengthParent - 1);

  const TAG = `${tag} ${newParent}`.toLowerCase();

  let result = false;
  tagFilter?.map(item => {
    if (TAG?.includes(item.toLowerCase()) || item.toLowerCase()?.includes(TAG)) {
      result = true;
    }
  });
  return !!result;
};

const handleReturnDataFilter = (listData: any[], tagFilter: any[]) => {
  return listData.map((item: any) => {
    return {
      title: item?.title,
      name: CONVERT_VALUE_FILTER[item?.name] || '',
      isChecked: handleCheckActiveFilter(item?.title || '', tagFilter || []),
      listSub:
        item?.listSub?.map((itemSub: any) => {
          return {
            title: itemSub?.title,
            name: CONVERT_VALUE_FILTER[itemSub?.name],
            isChecked: handleCheckActiveFilter(itemSub?.title || '', tagFilter || [], item?.title),
          };
        }) || [],
    };
  });
};

const adapter = (dataProps: any) => {
  const data: any = dataProps?.[0]?.blocksCollection?.items?.[0] ?? [];
  const dataFilter = handleReturnDataFilter(
    data?.listItemCollection?.listTags || [],
    data?.listItemCollection?.tagFilter || []
  );

  return {
    title: data?.title ?? '',
    categories: data?.listItemCollection?.items?.map((item: any) => ({
      title: item?.title ?? '',
      mainImage:
        item?.filterIcon262X160?.media?.url || item?.mastheadBackgroundImage?.media?.url || '',
      mainImageNext: '',
      slug: item?.slug || ''
    })),
    dataFilter: dataFilter,

    buttonPropsDone: data?.buttonPropsDone ?? {},
    buttonPropsClear: data?.buttonPropsClear ?? {},
    tagFilter: data?.listItemCollection?.tagFilter || '',
  };
};

const PADDING_COMPONENT: any = {
  '/news': {
    paddingTop: {
      xs: '72px',
      lg: '80px',
    },
    paddingBottom: {
      xs: '72px',
      lg: '40px',
    },
  },
};

const ScrollingNewsFilterOrganisms: React.FC<INewsFilterExt> = ({
  data,
  onQueryTags,
  onQueryGame,
  onActiveSlug,
  activeSlug
}) => {
  // console.log('ScrollingNewsFilterOrganisms data',data)
  const NewsFilterExtOrganismsProps = useMemo(() => adapter(data), [data]);
  // console.log('NewsFilterExtOrganismsProps',NewsFilterExtOrganismsProps)
  const {locale, pathname} = GetRouter();
  return (
    <Box sx={PADDING_COMPONENT[pathname] ?? PADDING_COMPONENT['/news']}>
      <Box
        sx={{
          '& .swiper-container': {
            overflow: 'hidden !important',
          },
        }}
      >
        <ScrollingNewsFilter
          {...NewsFilterExtOrganismsProps}
          locale={handleConvertToLocaleContentful(locale as string)}
          setDataQueryTags={(v: any) => onQueryTags(v)}
          setDataQueryGame={(v: any) => onQueryGame(v)}
          setActiveSlug={(v: any) => onActiveSlug(v)}
          //@ts-ignore
          activeSlug={activeSlug}
        />
      </Box>
    </Box>
  );
};

export default ScrollingNewsFilterOrganisms;
